<template>
  <div class="contract-related-matters">
    <div class="related-statuses" aria-label="关联事项状态">
      <el-button v-for="item in mainStatuses" :key="item.value" size="mini" :type="status === item.value ? 'primary' : ''" :aria-pressed="status === item.value" @click="changeStatus(item.value)">{{ item.label }}<span v-if="counts[item.value] != null"> {{ counts[item.value] }}</span></el-button>
      <el-select v-model="extraStatus" size="mini" class="related-more" placeholder="更多状态" aria-label="其他事项状态" clearable @change="changeExtraStatus">
        <el-option v-for="item in otherStatuses" :key="item.value" :value="item.value" :label="item.label + (counts[item.value] == null ? '' : ' ' + counts[item.value])" />
      </el-select>
    </div>
    <form class="related-filters" @submit.prevent="search">
      <el-select v-model="type" size="small" clearable filterable placeholder="全部类型" aria-label="事项类型" @change="search"><el-option v-for="item in types" :key="item.value" :value="item.value" :label="item.label" /></el-select>
      <el-input v-model="keyword" size="small" maxlength="100" clearable placeholder="搜索单号、主题或申请人" prefix-icon="el-icon-search" aria-label="搜索关联事项" @clear="search" />
      <el-button size="small" type="primary" native-type="submit">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" :loading="loading" @click="load">刷新</el-button>
    </form>
    <el-alert v-if="error" class="related-error" type="error" :title="error" :closable="false" show-icon><el-button type="text" @click="load">重试</el-button></el-alert>
    <el-table v-loading="loading" :data="rows" row-key="key" size="mini" class="related-table">
      <el-table-column label="事项" min-width="210">
        <template slot-scope="s">
          <el-tooltip :content="s.row.title || s.row.typeName" placement="top" :open-delay="400"><el-button type="text" class="related-title" @click="open(s.row)">{{ s.row.typeName }}<template v-if="s.row.title && s.row.title !== s.row.typeName"> · {{ s.row.title }}</template></el-button></el-tooltip>
          <div class="related-secondary"><span>{{ s.row.number || '未编业务单号' }}</span><span v-if="s.row.applicantName"> · {{ s.row.applicantName }}</span></div>
          <div v-if="s.row.relationLabel && s.row.relationLabel !== '直接关联'" class="related-secondary">{{ s.row.relationLabel }}</div>
        </template>
      </el-table-column>
      <el-table-column label="金额（元）" width="105" align="right"><template slot-scope="s"><div>{{ amount(s.row.amount) }}</div><div v-if="s.row.amountLabel && s.row.amountLabel !== '—'" class="related-secondary related-amount-label">{{ s.row.amountLabel }}</div></template></el-table-column>
      <el-table-column label="当前进度／处理人" min-width="140"><template slot-scope="s"><el-tag size="mini" :type="statusTone(s.row.status)">{{ s.row.statusText || '待确认' }}</el-tag><div class="related-secondary">{{ s.row.handlerNames || '—' }}</div></template></el-table-column>
      <el-table-column label="更新时间" width="108"><template slot-scope="s"><div class="related-date">{{ (s.row.updatedAt || '').slice(0, 10) || '—' }}</div><div class="related-secondary">{{ (s.row.updatedAt || '').slice(11, 16) }}</div></template></el-table-column>
      <el-table-column label="操作" width="56" fixed="right" align="right"><template slot-scope="s"><el-button type="text" size="mini" @click="open(s.row)">查看</el-button></template></el-table-column>
      <template slot="empty"><div class="related-empty">{{ error ? '关联事项暂时无法加载，请重试' : hasFilters ? '没有符合筛选条件的关联事项' : '暂无可查看的关联事项' }}<el-button v-if="hasFilters && !error" type="text" @click="reset">清除筛选</el-button></div></template>
    </el-table>
    <div class="related-footer"><span>仅展示当前账号可查看的关联事项；各类金额不合计。</span><el-pagination v-if="total > 0" small :current-page="page" :page-size="size" :total="total" :page-sizes="[10, 20, 50]" layout="total, prev, pager, next, sizes" @current-change="changePage" @size-change="changeSize" /></div>
    <el-dialog :title="selected ? selected.typeName : '审批记录'" :visible.sync="dialogVisible" width="min(900px, 94vw)" append-to-body destroy-on-close>
      <template v-if="dialogVisible && selected">
        <p class="related-dialog-title">{{ selected.title }}</p><p>{{ selected.number || '未编业务单号' }} · {{ selected.statusText }}</p>
        <approve-info :key="selected.workOrderId" :target-id="selected.workOrderId" :target-type="selected.targetType" :ledger-read-only="!!selected.ledgerReadOnly" :show-form-info="true" compact interaction-only />
      </template>
      <span slot="footer"><el-button v-if="selected && !selected.ledgerReadOnly" @click="openSource(selected)">查看原单据</el-button><el-button @click="dialogVisible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import { listContractRelatedMatters } from '@/api/crm/contractRelated'
import { messageSourceLocation } from '@/utils/messageSourceRoute'
import ApproveInfo from '@/views/crm/components/approveInfo'

export default {
  name: 'ContractRelatedMatters',
  components: { ApproveInfo },
  props: { contractId: { type: [Number, String], required: true } },
  data() {
    return {
      status: 'all', extraStatus: '', type: '', keyword: '', page: 1, size: 10,
      rows: [], total: 0, counts: {}, types: [], loading: false, error: '', sequence: 0,
      dialogVisible: false, selected: null,
      mainStatuses: [{ value: 'all', label: '全部' }, { value: 'pending', label: '进行中' }, { value: 'done', label: '已办结' }],
      otherStatuses: [{ value: 'returned', label: '已退回' }, { value: 'withdrawn', label: '已撤回' }, { value: 'offline', label: '线下已结束' }, { value: 'cancelled', label: '已作废' }]
    }
  },
  computed: { hasFilters() { return this.status !== 'all' || !!this.type || !!this.keyword.trim() } },
  watch: {
    contractId: { immediate: true, handler() { this.sequence++; this.status = 'all'; this.extraStatus = ''; this.type = ''; this.keyword = ''; this.page = 1; this.types = []; this.counts = {}; this.dialogVisible = false; this.selected = null; this.load() } }
  },
  beforeDestroy() { this.sequence++ },
  methods: {
    amount(value) { return value == null ? '—' : Number(value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) },
    statusTone(status) { return ({ pending: 'warning', done: 'success', returned: 'danger', withdrawn: 'info', offline: 'info' })[status] || 'info' },
    changeStatus(value) { this.status = value; this.extraStatus = ''; return this.search() },
    changeExtraStatus(value) { this.status = value || 'all'; return this.search() },
    search() { this.page = 1; return this.load() },
    reset() { this.status = 'all'; this.extraStatus = ''; this.type = ''; this.keyword = ''; return this.search() },
    changePage(value) { this.page = value; return this.load() },
    changeSize(value) { this.size = value; return this.search() },
    async load() {
      const seq = ++this.sequence
      this.rows = []; this.total = 0; this.counts = {}; this.error = ''
      if (!this.contractId) { this.loading = false; return }
      this.loading = true
      try {
        const response = await listContractRelatedMatters({ id: this.contractId, status: this.status, type: this.type || null, keyword: this.keyword.trim() || null, pageNum: this.page, pageSize: this.size })
        if (seq !== this.sequence) return
        const data = response.data || {}
        this.rows = data.rows || []; this.total = Number(data.total || 0); this.counts = data.counts || {}; this.types = data.types || []
        if (!this.rows.length && this.page > 1) { this.page = 1; return this.load() }
      } catch (e) {
        if (seq === this.sequence) { this.types = []; this.error = e.message || '关联事项加载失败，请重试' }
      } finally { if (seq === this.sequence) this.loading = false }
    },
    open(row) {
      if (row.kind === 'approval' && row.workOrderId) { this.selected = row; this.dialogVisible = true; return }
      return this.openSource(row)
    },
    openSource(row) {
      if (row.actionTab) { this.dialogVisible = false; this.$emit('open-tab', row.actionTab); return }
      const location = messageSourceLocation({ targetType: row.targetType, targetId: row.targetId })
      if (!location) { this.$message.info('请到原业务页面查看'); return }
      // A separate source page keeps the contract tab, filters and page position intact.
      window.open(this.$router.resolve(location).href, '_blank', 'noopener')
    }
  }
}
</script>

<style scoped>
.related-statuses { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; margin-bottom: 12px; }
.related-statuses .el-button + .el-button { margin-left: 0; }
.related-more { width: 130px; }
.related-filters { display: flex; flex-wrap: wrap; gap: 8px; margin: 0 0 16px; }
.related-filters > .el-select { width: 150px; }
.related-filters > .el-input { flex: 1; min-width: 180px; }
.related-filters .el-button { margin-left: 0; }
.related-error { margin-bottom: 12px; }
.related-title { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; white-space: normal; text-align: left; color: #303133; font-size: 13px; line-height: 1.6; padding: 0; max-width: 100%; }
.related-title:hover { color: #4480f3; }
.related-table { font-size: 13px; }
.related-secondary { color: #73767a; font-size: 12px; line-height: 1.6; overflow-wrap: anywhere; margin-top: 3px; }
.related-amount-label { line-height: 1.4; }
.related-date { white-space: nowrap; }
.related-table >>> .el-tag { white-space: normal; height: auto; line-height: 1.6; max-width: 100%; }
.related-empty { padding: 30px 8px; color: #909399; }
.related-empty .el-button { display: block; margin: 0 auto; }
.related-footer { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 12px; margin-top: 14px; }
.related-footer > span { font-size: 12px; color: #909399; }
.related-footer .el-pagination { margin-left: auto; max-width: 100%; white-space: normal; }
.related-dialog-title { font-weight: 600; overflow-wrap: anywhere; }
</style>
